"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var themes_1 = require("./themes");

exports.Heading1 = styled_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n"], ["\n  color: ", ";\n  font: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      inheritColor = _a.inheritColor;

  var _b, _c, _d, _e;

  return inheritColor ? 'inherit' : (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading1) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading1.color);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading1) === null || _d === void 0 ? void 0 : _d.font, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading1.font;
});
exports.Heading2 = styled_1.default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n"], ["\n  color: ", ";\n  font: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      inheritColor = _a.inheritColor;

  var _b, _c, _d, _e;

  return inheritColor ? 'inherit' : (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading2) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading2.color);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading2) === null || _d === void 0 ? void 0 : _d.font, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading2.font;
});
exports.Heading3 = styled_1.default.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n"], ["\n  color: ", ";\n  font: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      inheritColor = _a.inheritColor;

  var _b, _c, _d, _e;

  return inheritColor ? 'inherit' : (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading3) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading3.color);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading3) === null || _d === void 0 ? void 0 : _d.font, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading3.font;
});
exports.Heading4 = styled_1.default.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n"], ["\n  color: ", ";\n  font: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      inheritColor = _a.inheritColor;

  var _b, _c, _d, _e;

  return inheritColor ? 'inherit' : (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading4) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading4.color);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading4) === null || _d === void 0 ? void 0 : _d.font, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading4.font;
});
exports.Heading5 = styled_1.default.h5(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n"], ["\n  color: ", ";\n  font: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      inheritColor = _a.inheritColor;

  var _b, _c, _d, _e;

  return inheritColor ? 'inherit' : (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading5) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading5.color);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading5) === null || _d === void 0 ? void 0 : _d.font, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading5.font;
});
exports.Heading6 = styled_1.default.h1(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n"], ["\n  color: ", ";\n  font: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      inheritColor = _a.inheritColor;

  var _b, _c, _d, _e;

  return inheritColor ? 'inherit' : (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading6) === null || _d === void 0 ? void 0 : _d.color, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading6.color);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e;

  return _e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.heading6) === null || _d === void 0 ? void 0 : _d.font, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.texts.heading6.font;
});
exports.H1 = exports.Heading1;
exports.H2 = exports.Heading2;
exports.H3 = exports.Heading3;
exports.H4 = exports.Heading4;
exports.H5 = exports.Heading5;
exports.H6 = exports.Heading6;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;